/**
 * A-24: tình trạng kẽm CTP / khuôn gá của lệnh sản xuất — MỘT cách tính cho màn lệnh, lịch máy, xưởng.
 * Số bản / khuôn lấy đúng số dòng của lệnh (trước đây không có dòng nào vẫn hiện "4 bản", "1 khuôn").
 * Tín hiệu: readinessStatus của dòng (READY = sẵn sàng); đang ghi bản kẽm = thẻ [STATUS: BURNING] do máy chủ ghi.
 * Cờ plateStatus / moldStatus của lệnh mặc định READY nên chỉ dùng khi lệnh chưa có dòng kẽm / khuôn nào (31/10/2026).
 */
const isPlate = (t: any) => t?.toolingType === "PLATE" || t?.toolingType === "ZINC";

export function poToolingReadiness(po: any) {
  const toolings: any[] = po?.toolings || [];
  const plateToolings = toolings.filter(isPlate);
  const moldToolings = toolings.filter((t) => !isPlate(t));

  const isPlateReady =
    plateToolings.length > 0
      ? plateToolings.every((p) => p.readinessStatus === "READY")
      : po?.plateStatus === "READY" || Boolean(po?.isPlateExported);
  const isPlateBurning =
    !isPlateReady &&
    (po?.plateStatus === "BURNING" ||
      plateToolings.some((p) => typeof p.notes === "string" && p.notes.includes("[STATUS: BURNING]")));
  const isToolingReady =
    moldToolings.length > 0
      ? moldToolings.every((m) => m.readinessStatus === "READY")
      : po?.toolingStatus === "READY" || po?.moldStatus === "READY";

  const count = (n: number, unit: string) => (n > 0 ? `${n} ${unit}` : "chưa khai báo");
  return {
    plateToolings,
    moldToolings,
    isPlateReady,
    isPlateBurning,
    isToolingReady,
    plateCountText: count(plateToolings.length, "bản"),
    plateColorCountText: count(plateToolings.length, "màu"),
    moldCountText: count(moldToolings.length, "khuôn"),
  };
}
